<script>
// const link_url = "http://h6.hebeitongji.com"; //地址
// const link_url = "http://h7.hebeitongji.com"; //地址
const link_url = "http://h5.szcxmx.cn"; //地址

export default {
  link_url,
};
</script>


// WEBPACK FOOTER //
// src/Global.vue